import { render, staticRenderFns } from "./HomeTemplate.vue?vue&type=template&id=d270f564&scoped=true&"
import script from "./HomeTemplate.vue?vue&type=script&lang=ts&"
export * from "./HomeTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./HomeTemplate.vue?vue&type=style&index=0&id=d270f564&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d270f564",
  null
  
)

export default component.exports